import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from '../store'
import config from '../config'
import pluralizationRules from './plural.js'
import request from '@/helpers/request'
import Sentry from '@/modules/Sentry'
import { SUPPORTED_LANGUAGES } from '@/helpers/constants'
import { dateProvider } from '@/helpers/date'

Vue.use(VueI18n)

export const i18n = new VueI18n({
	locale: '', // set locale
	fallbackLocale: 'en',
	messages: {},
	pluralizationRules,
})

export async function loadLanguageAsync({ i18nLocaleOverride = null } = {}) {
	const queryParamLang = store.getters['location/getQueryParam']('lang')?.toLocaleLowerCase()
	const queryParamLpId = store.getters['location/getQueryParam']('lpid')

	if (queryParamLang && SUPPORTED_LANGUAGES.includes(queryParamLang)) {
		window.language = queryParamLang
	}

	const lang = window.language
	document.documentElement.setAttribute('lang', lang)
	document.documentElement.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr')

	if (i18n.locale === lang && !i18nLocaleOverride) {
		return
	}

	try {
		const response = await request(`${config('ApiLocalization')}${i18nLocaleOverride || lang}/web.json`)

		i18n.setLocaleMessage(lang, response)
		i18n.locale = lang
		store.commit('i18n/setLanguage', lang)

		dateProvider.loadLocaleAsync()

		if (queryParamLpId) {
			await store.dispatch('i18n/loadCustomLandingData')
		}

		store.commit('status/setResourceReadiness', 'i18n')

		document.title = i18n.t('common.main_pagetitle')
	} catch (e) {
		if (e.name !== 'AxiosError') {
			Sentry.captureException(e)
		}
	}
}
